import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: { main: '#050505', secondary: "#202226" }, // black
    secondary: { main: '#A78D78' }, // Beige
    tertiary: { main: '#D1593D' }, //Orange
    customColor: {
      green: '#136538',
      secondaryFirst: '#F0F0F0', // Light grey
      secondarySecond: "#656565", // Subtext
      secondaryThird: '#CBCBCB', // Dark grey
      secondaryfOURTH: '#757575', // Darkest grey
      white: '#FFFFFF',
      red: '#B60218',
      lightBeige: "#A78D781A",
      placeholder: "#959595",
      backdrop: 'rgba(0,0,0,.5)',
      secondaryRed: "#d32f2f",
      darkBeige:"#7D634F",
      secondaryBeige:"A78D78FF",
    },
  },
  typography: {
    fontFamily: ['Lexend', 'EB Garamond', 'serif'].join(','),
  },
  customStyles: {
    backdrop: {
      background: 'rgba(255, 255, 255, 0.01)',
      backdropFilter: 'blur(22px)',
    },
  },
  breakpoints: {
    values: {
      xs: 0, 
      xsl: 335,
      xs4: 415,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});
